export default "__VITE_ASSET__JIPzOQ3E__"